<template>
  <div>
    <v-layout v-if="!createMode" class="d-flex flex-row justify-space-between">
      <span>
        <v-tooltip max-width="30vw" v-if="node.meta.tooltip" left>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              :class="{ 'text-h6': isRoot, 'font-weight-medium': !isRoot }"
              v-text="node.name"
            ></span>
          </template>
          <div :class="{ 'text-h6': isRoot }" v-text="node.meta.tooltip"></div>
        </v-tooltip>
        <div v-if="!node.meta.tooltip">
          <div
            :class="{ 'text-h6': isRoot, 'font-weight-medium': !isRoot }"
            v-text="node.name"
          ></div>
        </div>
      </span>
      <div>
        <span v-if="hasScore(node._id)" class="text-subtitle-2">
          Score: {{ getScore(node._id) }}
        </span>
        <span class="text-body-2" v-if="node.children.length">
          <v-tooltip max-width="30vw" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" @click="scoreCat()" x-small>
                <v-icon small color="info">mdi-format-list-numbered-rtl</v-icon>
              </v-btn>
            </template>
            <span>Score this category and its children</span>
          </v-tooltip>
        </span>
      </div>
      <!-- <span v-if="editMode">
        <v-text-field
          v-model="node.name"
          :rules="[() => !!node.name || 'An entry is required']"
          label="Title"
          required
        ></v-text-field> 
      </span> -->
    </v-layout>
    <div v-if="createMode">
      <v-row>
        <v-col>
          <div class="d-flex justify-space-between full-width">
            <v-text-field
              label="Tooltip (optional)"
              v-model="node.meta.tooltip"
              class="mr-4"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { scoreNode } from "../../../utils/api";

export default {
  name: "NameInput",
  props: {
    node: Object,
    editMode: Boolean,
    editIndex: Number,
    createMode: { type: Boolean, default: false, required: false },
    singleEditModeid: String,
    selectedRecord: Object,
    isRoot: Boolean,
  },
  mounted() {
    this.$emit("validation", true);
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      getScore: "getScoreByNodeID",
      hasScore: "doesScoreExist",
      loginDetails: "getUser",
      getName: "getLoggedInName",
    }),
  },
  methods: {
    changeValue(e, node) {
      if (!e) {
        return;
      }
      node.name = e;
      node.authorName = this.getName;
      node.authorId = this.loginDetails.id;
    },
    async scoreCat() {
      const response = await scoreNode({
        rec_id: this.selectedRecord._id,
        node_id: this.node._id,
      });
      if (response?.Success) {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: `Scored category ${this.node.name}`,
        });
        this.$store.commit("SET_SCORE_FOR_NODE", {
          node_id: this.node._id,
          score: response.Success.total,
        });
      } else {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `Failed to score category ${this.node.name}`,
        });
      }
    },
  },
};
</script>
